import { requestGraphql } from '@/lib/backend';

import UpdateYAxisMutation from '@/lib/queries/UpdateYAxisMutation';

export default async function updateYAxis(
  session,
  graphql,
  pathname,
  dispatch,
  router,
  _yAxisLabelsRenderer,
  story,
  dataset,
  yAxisOriginalName,
  attributes,
  options?: { skipRedraw?: boolean; shouldRefreshRouter?: boolean }
) {
  const { data: _data, error } = await requestGraphql(
    session,
    graphql,
    pathname,
    UpdateYAxisMutation,
    'updateYAxis',
    {
      story_id: story.get('id'),
      dataset_id: dataset.get('id'),
      name: yAxisOriginalName,
      ...attributes,
    },
    'Y-Axis Update',
    {
      storyId: story.get('id'),
      storySlug: story.get('slug'),
    }
  );

  if (error) {
    dispatch({
      type: 'setFlashMessage',
      data: {
        type: 'error',
        message: `${error.errorType}: ${error.errorMessage}`,
      },
    });

    return;
  }

  if (options?.shouldRefreshRouter) {
    router.refresh();
  }
}
